import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import {SharedModule} from '../../../../shared/shared.module';
import {TextMaskModule} from 'angular2-text-mask';
import {DirectivesModule} from '../../../../../directives/directives.module';
import {ErrorsPageModule} from '../../../../shared/components/errors-page/errors-page.module';
import {JackingCompleteModalComponent} from './jacking-complete-modal.component';

@NgModule({
  declarations: [
    JackingCompleteModalComponent
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(JackingCompleteModalComponent),
    SharedModule,
    TextMaskModule,
    ErrorsPageModule
  ],
})
export class JackingCompleteModalComponentModule {}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-complete-modal/jacking-complete-modal.component.module.ts